import { TypeOfUse } from '../types/enums';

export const typeOfUseSelectLabels = {
  [TypeOfUse.SINGLE]: 'Single Use',
  [TypeOfUse.MULTIPLE]: 'Multiple Use',
};

export const getTypeOfUseSelectOptions = (t: (key: string) => string) => [
  {
    label: t(TypeOfUse.SINGLE),
    value: TypeOfUse.SINGLE,
  },
  {
    label: t(TypeOfUse.MULTIPLE),
    value: TypeOfUse.MULTIPLE,
  },
];
